import { Portal } from "src/components/navigation/Portal";
import { NavContextType } from "src/components/navigation/NavContext"
import { OperationsAdminVenueAreaBreadCrumb } from "src/components/operations/administrator/areas/OperationsAdminVenueAreaBreadcrumb";
import { OperationsAdminVenueAreaLayout } from "src/components/operations/administrator/areas/OperationsAdminVenueAreaLayout";
import { OperationsAdminVenueBookingBreadCrumb } from "src/components/operations/administrator/bookings/OperationsAdminVenueBookingBreadcrumb";
import { OperationsAdminVenueBookingLayout } from "src/components/operations/administrator/bookings/OperationsAdminVenueBookingLayout";
import { AppShellLayout } from "src/components/ui/AppShellLayout";
import { Icons } from "src/components/ui/Icons"

import { NotFound } from "src/screens/global/NotFound";
import { UserProfile } from "src/screens/user/UserProfile";
import { OperationsAdminVenueAreaGuidelines } from "src/screens/operations/administrator/areas/guidelines/OperationsAdminVenueAreaGuidelines";
import { OperationsAdminVenueArea } from "src/screens/operations/administrator/areas/OperationsAdminVenueArea";
import { OperationsAdminVenueAreas } from "src/screens/operations/administrator/areas/OperationsAdminVenueAreas";
import { OperationsAdminVenueBookingGuidelines } from "src/screens/operations/administrator/bookings/guidelines/OperationsAdminVenueBookingGuidelines";
import { OperationsAdminVenueBooking } from "src/screens/operations/administrator/bookings/OperationsAdminVenueBooking";
import { OperationsAdminVenueBookings } from "src/screens/operations/administrator/bookings/OperationsAdminVenueBookings";
import { OperationsAdminVenueGuidelines } from "src/screens/operations/administrator/guidelines/OperationsAdminVenueGuidelines";
import { OperationsAdminHome } from "src/screens/operations/administrator/OperationsAdminHome";
import { OperationsAdminVenueUsers } from "src/screens/operations/administrator/users/OperationsAdminVenueUsers";
import { OperationsAdminVenueTalentBreadCrumb } from "src/components/operations/administrator/talent/OperationsAdminVenueTalentBreadcrumb";
import { OperationsAdminVenueTalentLayout } from "src/components/operations/administrator/talent/OperationsAdminVenueTalentLayout";
import { OperationsAdminVenueTalentBlackouts } from "src/screens/operations/administrator/talent/blackouts/OperationsAdminVenueTalentBlackouts";
import { OperationsAdminVenueTalentDocuments } from "src/screens/operations/administrator/talent/documents/OperationsAdminVenueTalentDocuments";
import { OperationsAdminVenueTalentGuidelines } from "src/screens/operations/administrator/talent/guidelines/OperationsAdminVenueTalentGuidelines";
import { OperationsAdminVenueTalent } from "src/screens/operations/administrator/talent/OperationsAdminVenueTalent";
import { OperationsAdminVenueTalents } from "src/screens/operations/administrator/talent/OperationsAdminVenueTalents";
import { RouteDrawer } from "src/components/navigation/RouteDrawer";
import { OperationsAdminVenueTalentDocumentsOverlay } from "src/screens/operations/administrator/talent/documents/OperationsAdminVenueTalentDocumentsOverlay";
import { OperationsAdminVenueTalentOverlay } from "src/screens/operations/administrator/talent/OperationsAdminVenueTalentOverlay";
import { OperationsAdminVenueTalentGuidelinesOverlay } from "src/screens/operations/administrator/talent/guidelines/OperationsAdminVenueTalentGuidelinesOverlay";
import { OperationsAdminVenueTalentBlackoutsOverlay } from "src/screens/operations/administrator/talent/blackouts/OperationsAdminVenueTalentBlackoutsOverlay";
import { OperationsAdminVenueBookingOverlay } from "src/screens/operations/administrator/bookings/OperationsAdminVenueBookingOverlay";
import { OperationsAdminVenueBookingGuidelinesOverlay } from "src/screens/operations/administrator/bookings/guidelines/OperationsAdminVenueBookingGuidelinesOverlay";
import { OperationsAdminVenueDocuments } from "src/screens/operations/administrator/documents/OperationsAdminVenueDocuments";
import { OperationsAdminVenueAreaOverlay } from "src/screens/operations/administrator/areas/OperationsAdminVenueAreaOverlay";
import { OperationsAdminVenueAreaGuidelinesOverlay } from "src/screens/operations/administrator/areas/guidelines/OperationsAdminVenueAreaGuidelinesOverlay";
import { SuperAdminThreadOverlay } from "src/screens/superadmin/threads/SuperAdminThreadOverlay";
import { SuperAdminThreadLayout } from "src/components/superadmin/threads/SuperAdminThreadLayout";
import { OperationsAdminThreads } from "src/screens/operations/administrator/threads/OperationsAdminThreads";
import { SuperAdminThread } from "src/screens/superadmin/threads/SuperAdminThread";
import { SuperAdminThreadBreadCrumb } from "src/components/superadmin/threads/SuperAdminThreadBreadcrumb";
import { CalendarPortal } from "src/components/calendar/CalendarPortal";
import { OperationsAdminVenueBookingsCalendar } from "src/screens/operations/administrator/bookings/OperationsAdminVenueBookingsCalendar";

export const OperationsAdminRoutes = (): NavContextType => ({
    routes: [
        {
            path: '/',
            element: <AppShellLayout />,
            breadcrumb: 'Layout',
            children: [
                { index: true, element: <OperationsAdminHome />, breadcrumb: 'Home' },
                { path: "profile", element: <UserProfile />, breadcrumb: 'User Profile' },
                { path: "users", element: <OperationsAdminVenueUsers />, breadcrumb: 'Users' },
                { path: "guidelines", element: <OperationsAdminVenueGuidelines />, breadcrumb: 'Guidelines' },
                { path: "documents", element: <OperationsAdminVenueDocuments />, breadcrumb: 'Documents' },
                {
                    path: "inbox",
                    element: <Portal />,
                    breadcrumb: 'Inbox',
                    children: [
                        { index: true, element: <OperationsAdminThreads /> },
                        {
                            path: ":threadId",
                            element: <SuperAdminThreadLayout />,
                            children: [
                                { index: true, element: <SuperAdminThread />, breadcrumb: SuperAdminThreadBreadCrumb }
                            ]
                        }
                    ]
                },
                {
                    path: "calendar",
                    element: <CalendarPortal />,
                    breadcrumb: 'Calendar',
                    children: [
                        { index: true, element: <OperationsAdminVenueBookingsCalendar /> },
                    ]
                },
                {
                    path: "talent",
                    element: <Portal />,
                    breadcrumb: 'Talent',
                    children: [
                        { index: true, element: <OperationsAdminVenueTalents /> },
                        {
                            path: ":talentId",
                            element: <OperationsAdminVenueTalentLayout />,
                            children: [
                                { index: true, element: <OperationsAdminVenueTalent />, breadcrumb: OperationsAdminVenueTalentBreadCrumb },
                                { path: "guidelines", element: <OperationsAdminVenueTalentGuidelines />, breadcrumb: 'Guidelines' },
                                { path: "blackouts", element: <OperationsAdminVenueTalentBlackouts />, breadcrumb: 'Blackout Dates' },
                                { path: "documents", element: <OperationsAdminVenueTalentDocuments />, breadcrumb: 'Documents' } 
                            ]
                        }
                    ]
                },
                {
                    path: "bookings",
                    element: <Portal />,
                    children: [
                        { index: true, element: <OperationsAdminVenueBookings />, breadcrumb: 'Bookings' },
                        {
                            path: ":bookingId",
                            element: <OperationsAdminVenueBookingLayout />,
                            children: [
                                { index: true, element: <OperationsAdminVenueBooking />, breadcrumb: OperationsAdminVenueBookingBreadCrumb },
                                { path: "guidelines", element: <OperationsAdminVenueBookingGuidelines />, breadcrumb: 'Guidelines' }
                            ]

                        }
                    ]
                },
                {
                    path: "areas",
                    element: <Portal />,
                    children: [
                        { index: true, element: <OperationsAdminVenueAreas />, breadcrumb: 'Areas' },
                        {
                            path: ":areaId",
                            element: <OperationsAdminVenueAreaLayout />,
                            children: [
                                { index: true, element: <OperationsAdminVenueArea />, breadcrumb: OperationsAdminVenueAreaBreadCrumb },
                                { path: "guidelines", element: <OperationsAdminVenueAreaGuidelines />, breadcrumb: 'Guidelines' }
                            ]

                        }
                    ]
                },
                { path: "*", element: <NotFound />, breadcrumb: 'Not Found' }
            ]
        }
    ],
    overlays: [
        {
            path: "/inbox/:threadId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <SuperAdminThreadLayout />,
                    children: [
                        { index: true, element: <SuperAdminThreadOverlay /> }
                    ]
                }
            ],
        },
        {
            path: "/talent/:talentId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <OperationsAdminVenueTalentLayout />,
                    children: [
                        { index: true, element: <OperationsAdminVenueTalentOverlay /> },
                        { path: "guidelines", element: <OperationsAdminVenueTalentGuidelinesOverlay /> },
                        { path: "blackouts", element: <OperationsAdminVenueTalentBlackoutsOverlay /> },
                        { path: "documents", element: <OperationsAdminVenueTalentDocumentsOverlay /> },
                    ]
                }
            ],
        },
        {
            path: "/bookings/:bookingId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <OperationsAdminVenueBookingLayout />,
                    children: [
                        { index: true, element: <OperationsAdminVenueBookingOverlay /> },
                        { path: "guidelines", element: <OperationsAdminVenueBookingGuidelinesOverlay /> },
                    ]
                }
            ],
        },
        {
            path: "/areas/:areaId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <OperationsAdminVenueAreaLayout />,
                    children: [
                        { index: true, element: <OperationsAdminVenueAreaOverlay /> },
                        { path: "guidelines", element: <OperationsAdminVenueAreaGuidelinesOverlay /> },
                    ]
                }
            ],
        },
    ],
    menu: [
        {
            to: '/',
            label: 'Home',
            icon: Icons.home
        },
        {
            to: '/inbox',
            label: 'Inbox',
            icon: Icons.inbox
        },
        {
            to: '/calendar',
            label: 'Calendar',
            icon: Icons.calendar
        },
        {
            to: '/bookings',
            label: 'Bookings',
            icon: Icons.booking
        },
        {
            to: '/areas',
            label: 'Areas',
            icon: Icons.area
        },
        {
            to: '/guidelines',
            label: 'Guidelines',
            icon: Icons.guideline
        },
        {
            to: '/documents',
            label: 'Documents',
            icon: Icons.files
        },
        {
            to: '/talent',
            label: 'Talent',
            icon: Icons.user
        },
        {
            to: '/users',
            label: 'Users',
            icon: Icons.user
        }
    ],
    mobile: [
        {
            to: '/',
            label: 'Home',
            icon: Icons.home
        },
        {
            to: '/inbox',
            label: 'Inbox',
            icon: Icons.inbox
        },
        {
            to: '/calendar',
            label: 'Calendar',
            icon: Icons.calendar
        },
        {
            to: '/bookings',
            label: 'Bookings',
            icon: Icons.booking
        },
        {
            to: '/areas',
            label: 'Areas',
            icon: Icons.area
        },
        {
            to: '/guidelines',
            label: 'Guidelines',
            icon: Icons.guideline
        },
        {
            to: '/documents',
            label: 'Documents',
            icon: Icons.files
        },
        {
            to: '/talent',
            label: 'Talent',
            icon: Icons.user
        },
        {
            to: '/users',
            label: 'Users',
            icon: Icons.user
        }
    ]
})
